"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _framerMotion = require("framer-motion");

var _clsx = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _close = _interopRequireDefault(require("./close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette$backgr, _theme$palette, _theme$palette$backgr2, _theme$palette$backgr3;

  return {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      zIndex: 100,
      "& .menu-01-mobile-close": _defineProperty({
        padding: theme === null || theme === void 0 ? void 0 : theme.spacing(2, 3)
      }, theme.breakpoints.up("lg"), {
        margin: theme === null || theme === void 0 ? void 0 : theme.spacing(3),
        padding: theme === null || theme === void 0 ? void 0 : theme.spacing(3)
      })
    },
    backdrop: {
      background: (_theme$palette$backgr = theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$backgr2 = _theme$palette.background) === null || _theme$palette$backgr2 === void 0 ? void 0 : (_theme$palette$backgr3 = _theme$palette$backgr2.menu01) === null || _theme$palette$backgr3 === void 0 ? void 0 : _theme$palette$backgr3.menuMobileBackdropLayer1) !== null && _theme$palette$backgr !== void 0 ? _theme$palette$backgr : "#9CB0A5",
      borderRadius: "0 0 25% 0",
      left: 0,
      position: "fixed",
      top: 0,
      width: 0,
      zIndex: 99
    }
  };
});

var MobileContainer = function MobileContainer(props) {
  var css = useStyles();
  var iconClose = props.iconClose,
      close = props.close;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
    className: (0, _clsx.default)("menu-01-mobile-backdrop", css.backdrop),
    animate: {
      height: "125%",
      width: "125%"
    },
    transition: {
      duration: 0.5
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("menu-01-mobile-container", css.root)
  }, /*#__PURE__*/_react.default.createElement(_close.default, {
    className: css.close,
    close: close,
    icon: iconClose
  }), props.children));
};

MobileContainer.propTypes = {
  close: _propTypes.default.func.isRequired,
  iconClose: _propTypes.default.string.isRequired
};
var _default = MobileContainer;
exports.default = _default;